import { RootState } from 'store/rootReducer';

export const CookiePolicyContentSelector = (state: RootState) => state.content.cookiePolicy;
